import { onAuthStateChanged } from "firebase/auth";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Header, Footer, Navbar, ScrollTop } from "./components";
import {
  Home,
  Courses,
  Course,
  Login,
  Signup,
  Contact,
  Cart,
  Checkout,
  Plans,
  Dashboard,
  Account,
  Allcourses,
  Wishlist,
  Inprogress,
  Completed,
  Videoplayer,
  NoMatch,
  VerifyEmail,
} from "./pages";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "./firebaseSetup";
import { login, logout, selectUser } from "./services/userSlice";
import PrivateRoute from "./pages/PrivateRoute";

function App() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  console.log(user);

  useEffect(() => {
    onAuthStateChanged(auth, (userAuth) => {
      if (userAuth) {
        // user is logged in, send the user's details to redux, store the current user in the state
        dispatch(
          login({
            ...userAuth,
          }),
        );
      } else {
        dispatch(logout());
      }
    });
  }, [dispatch]);

  return (
    <Router>
      <ScrollTop>
        <Header />
        <Navbar />
        <AnimatePresence>
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            <Route
              path="/courses"
              element={<Courses />}
            />
            <Route
              path="/course/:courseId"
              element={<Course />}
            />
            <Route
              path="/login"
              element={
                !user?.emailVerified ? (
                  <Login />
                ) : (
                  <Navigate
                    to="/dashboard"
                    replace
                  />
                )
              }
            />
            <Route
              path="/contact"
              element={<Contact />}
            />
            <Route
              path="/signup"
              element={
                !user?.emailVerified ? (
                  <Signup />
                ) : (
                  <Navigate
                    to="/dashboard"
                    replace
                  />
                )
              }
            />
            <Route
              path="/cart"
              element={<Cart />}
            />
            <Route
              path="/plans"
              element={<Plans />}
            />
            <Route
              path="/checkout"
              element={!user?.emailVerified ? <Signup /> : <Checkout />}
            />
            <Route
              path="/verify-email"
              element={<VerifyEmail />}
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<Allcourses />}
              />
              <Route
                path="all-courses"
                element={<Allcourses />}
              />
              <Route
                path="my-account"
                element={<Account />}
              />
              <Route
                path="wishlist"
                element={<Wishlist />}
              />
              <Route
                path="in-progress"
                element={<Inprogress />}
              />
              <Route
                path="completed"
                element={<Completed />}
              />
              <Route
                path="videoplayer"
                element={<Videoplayer />}
              />
            </Route>
            <Route
              path="*"
              element={<NoMatch />}
            />
          </Routes>
        </AnimatePresence>
        <Footer />
      </ScrollTop>
    </Router>
  );
}

export default App;
